import React from "react";

import '../styles/about/about-us.scss'

const AboutUs = () => {
    return (
        <div className="about-container">
            <h1>About us</h1>
            <p>Hello, we are the creators of this NTUMods. One of us is responsible for the design and the other is responsible for the programming of it.
                As we are graduating soon, we will be dropping this project. Feel free to press the github link in the footer and contribute to it!
            </p>
            <br></br>
            <p>
                NOTE: The information in this webpage is only accurate for Semester 1 of AY20/21
            </p>
        </div>
    )
};

export default AboutUs;